export default {
  ja:[
    "送り先を確認してください",
    "名前",
    "郵便番号",
    "市区町村以下",
    "市区町村",
    "都道府県",
    "国",
    "ζ*'ヮ')ζ＜ 送ってあげてね！",
    "送ったら配送完了ボタンを押してね！",
    "配送完了"
  ],
  en: [
    "Please check the buyer address!",
    "name",
    "postcode",
    "street",
    "address",
    "prefecture",
    "country",
    `ζ*'ヮ')ζ＜ All ready? Time to ship the item!\nIf you're ready to ship the item, then click the "Shipped" button below!`,
    `Already shipped? Don't forget to click the "shipped" button`,
    "Shipped",
  ]
}
